import { PageHeader } from '@/components/shared/page-header';
import { ServerSdkCard } from '@/components/sdk/server-sdk-card';

/** Resources (P5.17): SDK downloads for now. Global, like Queues & DLQ: releases belong to no application. */
export function Resources() {
  return (
    <div className="space-y-6">
      <PageHeader title="Resources" description="Packages your backends install to send notifications. Each download link is valid for 5 minutes." />
      <ServerSdkCard />
    </div>
  );
}
